import React, { useEffect, useState, useMemo } from "react";
import { Page } from "components/common";
import { DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } from "reactstrap";
import BackButton from "components/refactoring/BackButton";
import { Trans } from "react-i18next";
import { useOrganisationContext, useUserContext } from "hooks";
import { ApiClient, } from "services";
import person_icon from "assets/images/person.svg";
import RowList from "./Rows/List";
import EditStage from "./Stages/Edit";
import InviteEmployees from "./InviteEmployees";
import useModal from "hooks/useModal";

const HeaderData = ({ data }) => { // to display stages and their count
    return (
        <div className="d-flex justify-content-start mb-0 mt-2 overflow-x auto-scroll py-1">
            {data?.map((item, idx) =>
                <div key={idx} className={`w-100  justify-content-between d-flex align-items-center ${item.color ?? ""} p-3`}>
                    <span>{item?.name}</span> <span className="float-right"><h4 className="mb-0 ml-2">{item?.count}</h4></span>
                </div>
            )}
        </div>
    );
};

export const ListDetails = ({ t, match }) => {
    const list_id = match.params.id;
    const { selectedOrganisation } = useOrganisationContext();
    const { user } = useUserContext();
    const orgID = selectedOrganisation?.id
    const client = ApiClient();

    const [stageAddToggle, setStageAddToggleModal] = useState(false);
    const [stageRows, setStageRows] = useState([]);
    const { Modal: InviteModal, toggle: toggleInvite, isOpen: isInviteOpen } = useModal();
    const [listEmployees, setListEmployees] = useState({ listInvitedEmployees: {}, employeesOptions: [] });
    const [filteredStageRows, setFilteredStageRows] = useState([]);


    const stageAddToggleModal = () => setStageAddToggleModal(!stageAddToggle);

    const options = ['text', 'choice', 'date', 'yes_no', 'number', 'textarea', 'hyperlink', 'image'];

    useEffect(() => {
        getOrgEmployees();
        getListStageRows();
        getInvitedEmployees();
    }, []);

    const getInvitedEmployees = async () => {
        const employees_in_list = await client.get(`streak-list/${orgID}/invite-employees/${list_id}`).get("data");
        setListEmployees(prevState => ({
            ...prevState,
            listInvitedEmployees: employees_in_list,
        }));
    };

    const getListStageRows = async () => {
        const response  = await client.get(`list-details/${list_id}/pipeline-stage`);
        const stage_rows = response.data;
        setStageRows(stage_rows);
    };

    const getOrgEmployees = async () => {
        const employees = await client.get(`payroll/${orgID}/employees`).get("data");
        setListEmployees(prev => ({ ...prev, employees: employees }));
    };

    const headerData = useMemo(() => (
        stageRows?.map((item) => ({
            name: item?.name,
            count: item?.list_stage_rows?.length,
            color: item?.color_class,
        }))
    ), [stageRows]);

    
    const full_control_permission = useMemo(() => (
        listEmployees?.listInvitedEmployees?.employees?.find(
            (employee) => (employee?.user === user?.id || employee?.employee !== null)
        )?.permission
    ), [listEmployees, user]);

    return (
        <>
            <Page title={t(`List Details`)}>
                <div className="d-flex justify-content-between align-items-center">
                    <BackButton />
                    {full_control_permission === "Full Control"  && (
                        <div className="d-flex align-items-center">
                            <div className="mr-2">
                                <img className="personIcon " src={person_icon} alt="person" />
                            </div>
                            <div className="clickable" onClick={() => toggleInvite()}>
                                <span className=""><Trans>Manage Access</Trans></span>
                            </div>
                        </div>
                    )}
                </div>
                <div className="row">
                    <div className={`${listEmployees?.listInvitedEmployees?.color_class} p-1 ml-3`}>
                    </div>
                    <div className={`col mt-2 px-1`} md="6">
                        <h5 color="primary" className="text-weight-bold"><strong>{listEmployees?.listInvitedEmployees?.name}</strong></h5>
                    </div>
                    <div className="col text-right" md="6">
                        <div>
                            <UncontrolledDropdown>
                                <DropdownToggle
                                    color="white"
                                    className="bg-white border-0 no-shadow"
                                >
                                    <i className="fas fa-ellipsis-v clickable"></i>
                                </DropdownToggle>
                                <DropdownMenu dark>
                                    <DropdownItem onClick={stageAddToggleModal}>
                                        <Trans>Stages</Trans>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </div>
                </div>
                <HeaderData data={headerData} />
                <RowList
                    t={t}
                    stageRows={stageRows}
                    filteredStageRows={filteredStageRows}
                    selectedOrganisation={selectedOrganisation}
                    getListStageRows={getListStageRows}
                    options={options}
                    list_id={list_id}
                    client={client}
                    setFilteredStageRows={setFilteredStageRows}
                />
            </Page>

            {isInviteOpen ?
                <InviteModal>
                    <InviteEmployees
                        toggle={toggleInvite}
                        isOpen={isInviteOpen}
                        listInvitedEmployees={listEmployees.listInvitedEmployees}
                        employeeOptions={listEmployees.employees}
                        list_id={list_id}
                        client={client}
                        selectedOrganisation={selectedOrganisation}
                        getInvitedEmployees={getInvitedEmployees}
                    />
                </InviteModal>
                : null}

            <EditStage
                getListStageRows={getListStageRows}
                list_id={list_id}
                client={client}
                stageAddToggleModal={stageAddToggleModal}
                stageAddToggle={stageAddToggle}
                t={t}
                stageRows={stageRows}
            />
        </>
    );
};

export default ListDetails;
